'use client';

import dynamic from 'next/dynamic';

const PropertyPage = dynamic(() => import('_pages/PropertyPage'), {
  ssr: false,
});

export default function PropertyPageClient({ id, locale }) {
  return <PropertyPage key={locale} id={id} locale={locale} />;
}

